import classNames from "classnames";
import { useState } from "react";

import { GeneratorV2 } from "./GeneratorV2";
import styles from "./GeneratorV2DevPage.module.scss";
import * as mock from "./mock";
import type { V2LogbookDef } from "./types";

const LOGBOOKS: Record<string, { label: string; data: object }> = {
  spec: { label: "General Spec", data: mock.spec },
  groups: { label: "Groups", data: mock.groups },
  dailyLog: { label: "Daily Log", data: mock.dailyLog },
  draak: { label: "Draak Engine Log", data: mock.draak },
  oilRecord: { label: "Oil Record 1", data: mock.oilRecord },
  test: { label: "Test", data: mock.test },
};

export function GeneratorV2DevPage() {
  const [active, setActive] = useState<string>("spec");
  const def = LOGBOOKS[active].data as V2LogbookDef;

  return (
    <div className={styles.page}>
      {/* Toolbar */}
      <div className={styles.toolbar}>
        <span className={styles.toolbarTitle}>GeneratorV2 Dev</span>
        <div className={styles.tabs}>
          {Object.entries(LOGBOOKS).map(([key, lb]) => (
            <button
              key={key}
              type="button"
              className={classNames(
                styles.tab,
                active === key && styles.tabActive,
              )}
              onClick={() => setActive(key)}>
              {lb.label}
            </button>
          ))}
        </div>
      </div>

      {/* Generator */}
      <div className={styles.canvas}>
        <GeneratorV2 key={active} logbookDef={def} entryInfo={null} />
      </div>
    </div>
  );
}
